{{#each allInstanceVariablesWithSetterCallRequired delimeter="\n"}}
{{> (partial "snippets/check-instance-variable-set") handle=. beforeMessage=(or (and (not ../isComponent) " before randomizing") "")}}
{{/each}}
